import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Temp from './temp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Temp />
  </React.StrictMode>
);